// Super Bowl / game-day stubs — finger food, dips, wings, party
// portions. Surface 2 weeks before Super Bowl Sunday + on weekend
// game-day windows.

export const SUPERBOWL_STUBS = [
  {
    id: "buffalo-wings",
    title: "Buffalo Wings",
    emoji: "🍗",
    blurb: "Crispy wings tossed in butter-hot sauce",
    discoveryTags: ["superbowl", "game-day", "cookout", "kids", "comfort-food"],
    cuisine: "american",
    course: "appetizer",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 60,
    keyIngredients: ["chicken_wings", "hot_sauce", "butter", "blue_cheese"],
    buildHint: "baking powder + dry pat for oven-crispy skin, 425F flipping halfway, toss in melted butter + Frank's, serve with blue cheese + celery",
    producesCanonical: null,
  },
  {
    id: "seven-layer-dip",
    title: "Seven Layer Dip",
    emoji: "🥑",
    blurb: "Refried beans, guac, sour cream, the works",
    discoveryTags: ["superbowl", "game-day", "kids", "cookout"],
    cuisine: "mexican",
    course: "appetizer",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 20,
    keyIngredients: ["refried_beans", "avocado", "sour_cream", "salsa", "cheddar", "olives", "tortilla_chips"],
    buildHint: "build in a clear dish so layers show — beans seasoned warm, guac with lime, sour cream + taco seasoning, salsa drained, cheese, olives, scallions",
    producesCanonical: null,
  },
  {
    id: "spinach-artichoke-dip",
    title: "Spinach Artichoke Dip",
    emoji: "🧀",
    blurb: "Hot, melty, bubbly with bread for dunking",
    discoveryTags: ["superbowl", "game-day", "comfort-food", "cookout"],
    cuisine: "american",
    course: "appetizer",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 35,
    keyIngredients: ["spinach", "artichoke_hearts", "cream_cheese", "mozzarella", "parmesan", "garlic"],
    buildHint: "squeeze spinach DRY or it'll water out, mix with cream cheese + sour cream + cheeses + garlic, bake 400F 20 min until bubbly browned top",
    producesCanonical: null,
  },
  {
    id: "loaded-nachos",
    title: "Loaded Nachos",
    emoji: "🌮",
    blurb: "Cheesy, beefy, all the toppings",
    discoveryTags: ["superbowl", "game-day", "kids", "cookout", "late-night"],
    cuisine: "mexican",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 30,
    keyIngredients: ["tortilla_chips", "ground_beef", "cheddar", "black_beans", "salsa", "jalapenos"],
    buildHint: "layer chips + cheese + seasoned beef + beans TWICE so middle gets goods, broil 2 min for melt, top fresh — pico, sour cream, jalapeños, scallions",
    producesCanonical: null,
  },
  {
    id: "pigs-in-blankets",
    title: "Pigs in a Blanket",
    emoji: "🌭",
    blurb: "Cocktail franks in flaky pastry",
    discoveryTags: ["superbowl", "game-day", "kids", "christmas", "newYearsEve"],
    cuisine: "american",
    course: "appetizer",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["cocktail_franks", "puff_pastry", "mustard"],
    buildHint: "cut puff pastry in triangles, wrap each frank tight, egg wash + sesame or poppy seeds, bake 400F 15 min until golden",
    producesCanonical: null,
  },
];
